<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <div class="row m-t-20">
        <div class="col-lg-12">
          <h4 class="card-title">
            {{ principleIndex }}. {{ principle.description }}
          </h4>
          <h4 class="card-subtitle" v-if="principle.objective">
            {{ principle.objective }}
          </h4>
        </div>
      </div>
      <div class="row m-t-10">
        <template v-for="(criterion, index) in principle.criteria">
          <criteria :auditId="auditId" :auditor="auditor" :certificationId="certificationId"
                    :criteria="criterion" :id="principleIndex+'.'+(index+1)" :impactArea="impactArea"
                    :principleId="principle.principle" :status="auditStatus"/>
        </template>

        <template v-if="principle.criteria.length === 0">
          <div class="col-sm-12 col-md-12 table-responsive  ">
            <table class="table table-bordered">
              <thead class="card-print">
              <tr>
                <th rowspan="2">
                  Id
                </th>
                <th rowspan="2">
                  Obligation
                </th>
                <th rowspan="2">
                  Description
                </th>
                <th colspan="3">
                  Observation
                </th>
              </tr>
              <tr>
                <th>Compliance</th>
                <th>Notes</th>
                <th>Created At</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="indicator in indicators">
                <tr class="m-t-10 card-print">
                  <td :rowspan="indicator.observations.length == 0 ?1:indicator.observations.length" class="text-left">
                    {{ indicator.control_point_name }}
                  </td>
                  <td :rowspan="indicator.observations.length == 0 ?1:indicator.observations.length" class="text-left">
                    <span v-if="indicator.obligation === 'MAJOR_MUST'">Major Must</span>
                    <span v-if="indicator.obligation === 'MINOR_MUST'">Minor Must</span>
                  </td>
                  <td :rowspan="indicator.observations.length == 0 ?1:indicator.observations.length">
                    {{ indicator["description"] }}
                  </td>
                  <td>
                    <template v-if="indicator.observations.length > 0">
                      <span v-if="indicator.observations[0].compliance === 'Compliant'" class="text-dark-green">Compliant</span>
                      <span v-if="indicator.observations[0].compliance === 'NonCompliant'" class="text-danger">Non-Compliant</span>
                      <span v-if="indicator.observations[0].compliance === 'NotApplicable'" class="text-secondary">Not Applicable</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="indicator.observations.length > 0">
                      <span v-html="indicator.observations[0].procedural_note" />
                    </template>
                  </td>
                  <td>
                    <template v-if="indicator.observations.length > 0">
                      <span v-html="indicator.observations[0].created_at" />
                    </template>
                  </td>
                </tr>
                <template v-for="(observation, i) in indicator.observations">
                  <tr v-if="i > 0">
                    <td>
                      <span v-if="observation.compliance === 'Compliant'" class="text-dark-green">Compliant</span>
                      <span v-if="observation.compliance === 'NonCompliant'" class="label label-danger">Non-Compliant</span>
                      <span v-if="observation.compliance === 'NotApplicable'" class="label label-secondary">Not Applicable</span>
                    </td>
                    <td>
                      <span v-html="observation.procedural_note" />
                    </td>
                    <td>{{ observation.created_at }}</td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import Criteria from './Criteria.vue';
  import Indicator from './Indicator.vue';

  export default {
    name: 'Principle',
    components: {Indicator, Criteria},
    props: ['auditId', 'principle', 'principleIndex', 'impactArea', 'events', 'auditStatus', 'auditor', 'certificationId'],
    data() {
      return {
        indicators: []
      };
    },
    mounted() {
      if (this.principle && this.principle.criteria.length === 0) {
        this.getIndicators();
      }
    },
    methods: {
      async getIndicators() {
        this.indicators = [];
        try {
          const {data} = await this.$api.get(`audits/certifications/${this.certificationId}/impact_areas/${this.impactArea}/principles/${this.principle.principle}/control_points`);
          for (let i = 0; i < data.length; i++) {
            // eslint-disable-next-line no-unused-vars
            let observations = (await this.$api.get(`audits/${this.auditId}/control_points/${data[i].control_point_id}/observations`)).data;
            data[i]['observations'] = observations;
          }
          this.indicators = data;
        } catch (e) {
          console.error(e);
        }
      },
      getPityName(name) {
        return name.substring(name.indexOf(' '));
      }
    }
  }
</script>

<style scoped>
</style>
